<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <div>
        <a-form :form="form">
          <a-form-item label="收款类型" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-select
              allow-clear
              v-decorator="[
                'collection_category',
                {
                  rules: [
                    { required: true, message: '请选择' },
                  ],
                },
              ]"
              placeholder="请选择"
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option :key="key" :value="key" v-for="(val, key) in collectionCategoryList">{{ val }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="币种" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
              v-decorator="[
                'currency',
                {
                  rules: [
                    { required: true, message: '请选择' }
                  ],
                },
              ]"
              placeholder="选择"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              @change="currencyChange"
            >
              <a-select-option :key="key" :value="key" v-for="(val, key) in this.currency">{{ val }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-if="this.selectedCurrency !== undefined && this.selectedCurrency !== '142'" label="结汇汇率" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-input-number :precision="4" style="width: 50%" v-decorator="['purchase_rate', {rules: [{required: true, message: '必填项，请填写信息'}]}]" @change="purchaseRateChange" placeholder="汇率"/>
          </a-form-item>
          <a-form-item label="收款金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number :precision="4" style="width: 50%" v-decorator="['amount', {rules: [{required: true, message: '必填项，请填写信息'}]}]" @change="amountChange"/>
          </a-form-item>
          <a-form-item v-if="this.selectedCurrency !== undefined && this.selectedCurrency !== '142'" label="本币金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number :precision="4" style="width: 50%" v-decorator="['amount_cny', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
          </a-form-item>
          <a-form-item label="支付方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
              v-decorator="[
                'method',
                {
                  rules: [
                    { required: true, message: '请选择' }
                  ],
                },
              ]"
              placeholder="选择"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption2"
            >
              <a-select-option :key="key" :value="key" v-for="(val, key) in this.method">{{ val }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="支付时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-date-picker
              style="width:100%"
              v-decorator="['pay_time', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
              format="YYYY-MM-DD HH:mm:ss"
              show-time
              placeholder="请选择时间"
              @ok="payTimeOK"
            />
          </a-form-item>
          <a-form-item v-if="false" label="已存档" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-switch v-decorator="['is_archived', {rules: [{required: false, message: '必填项，请填写信息'}]}]" checked-children="是" un-checked-children="否"/>
          </a-form-item>
          <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea :rows="4" v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}]}]" />
          </a-form-item>
          <a-form-item v-bind="buttonCol">
            <a-row>
              <a-col span="6">
                <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
              </a-col>
              <a-col span="10">
                <a-button @click="handleGoBack">返回</a-button>
              </a-col>
              <a-col span="8"></a-col>
            </a-row>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { collection_list, collection_update } from '@/api/trade_collection'
const fields = ['id', 'collection_category', 'amount', 'currency', 'purchase_rate', 'amount_cny', 'method', 'pay_time', 'is_archived', 'remark']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      currency: this.$Dictionaries.currency,
      method: this.$Dictionaries.trade_payment_method,
      collectionCategoryList: this.$Dictionaries.trade_collection_category,
      data: {},
      purchaseRate: 0,
      selectedCurrency: undefined,
      loading: false,
      amount: 0
    }
  },
  created () {
    fields.forEach(v => this.form.getFieldDecorator(v))
  },
  mounted () {
    this.loadCollectionData()
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    loadCollectionData () {
      this.loading = true
      collection_list({ id: this.$route.params.id })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.data.collection_category = '' + this.data.collection_category
            this.data.method = '' + this.data.method
            this.id = this.data.id
            this.selectedCurrency = this.data.currency
            this.loadEditInfo(this.data)
          }
        }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (!err) {
          console.log('我要提交接口1', values)
          collection_update(values, this.id)
            .then((res) => {
              console.log(res, '修改')
              if (res.code === 1000) {
                this.handleGoBack()
              }
            })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        console.log('formData', formData)
        this.id = formData.id
        form.setFieldsValue(formData)
      })
    },
    currencyChange (value) {
      this.selectedCurrency = value
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    filterOption2 (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    payTimeOK (value) {
      console.log(value.format('YYYY-MM-DD HH:mm:ss'))
      this.form.setFieldsValue({
        pay_time: value.format('YYYY-MM-DD HH:mm:ss')
      })
    },
    purchaseRateChange (value) {
      this.purchaseRate = value
      if (this.purchaseRate === 0 || this.amount === 0) {
        return
      }
      const result = (this.purchaseRate * this.amount).toFixed(4)
      console.log(result)
      this.form.setFieldsValue({
        amount_cny: result
      })
    },
    amountChange (value) {
      this.amount = value
      if (this.purchaseRate === 0 || this.amount === 0) {
        return
      }
      const result = (this.purchaseRate * this.amount).toFixed(4)
      console.log(result)
      this.form.setFieldsValue({
        amount_cny: result
      })
    }
  }
}
</script>
